import React from "react";

export default function BridgeCard({
  bridgeImge,
  bridgeTitle,
  active = false,
  content,
  url,
  urlName,
}) {
  return (
    // <div className="w-full min-h-[268px] group relative flex flex-col h-full items-start gap-3 lg:px-[20px] py-[15px] bg-white hoverCardTop p-6 lg:p-8 duration-300 overflow-hidden">
    <div className={`w-full min-h-[268px]  relative bg-CardBG items-startgap-3  bg-no-repeat bg-cover bg-right-bottom hoverCardTop p-6 lg:p-8 overflow-hiddenrelative bg-white ${active&&'hover:!bg-[#1B2129]  hover:!text-white group gap-5w-full duration-300  bg-CardBG bg-no-repeat bg-cover bg-right-bottom before:absolute before:bg-contain hover:before:bg-[#1B2129]/80 before:bg-no-repeat before:bg-right-bottom before:bg-yellowDotBg before:bottom-0 before:h-full before:right-0 before:w-full before:z-[-1]'}`}>
      {!active && (
        <div className="absolute top-0 left-0 w-full h-full z-10 font-sans bg-white/40 text-black flex items-center justify-center  text-xl leading-none font-semibold -tracking-[0.8px] px-[14px] py-3 capitalizebg-green/[0.08]  ">
          Coming soon
        </div>
      )}

      <div
        className={`absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-green/80  ${
          !active && "blur-[20px]"
        }`}
      >
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path d="M12 14L12 2L0 2" stroke="currentColor" strokeWidth="2.5" />
        </svg> */}
      </div>
      <div
        className={`absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white  ${
          !active && "blur-[20px]"
        }`}
      >
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path d="M8 0L8 8L0 8" stroke="currentColor" strokeWidth="2.5" />
        </svg> */}
      </div>

      <div
        className={`flex flex-col justify-between h-full relative z-[1] ${
          !active && "blur-[12px]"
        }`}
      >
        <div className="flex justify-between w-full">
          <div className="flex items-center gap-4 laptop:gap-5">
            <div className="flex items-center justify-center p-[13px] laptop:p-[17px] w-[80px] h-[80px] laptop:w-[72px] laptop:h-[72px] rounded-xl bg-[#010101]">
              {bridgeImge}
            </div>

            <div className="flex flex-col gap-3 laptop:gap-[8px]">
              <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-gunMetal group-hover:text-white font-sans">
                {bridgeTitle}
              </h4>
              <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-semibold -tracking-04 px-[12px] py-[5px] text-green capitalize bg-green/[0.08] rounded-[4px] h-6 max-w-fit  bg-accordientGD">
                Active
              </div>
            </div>
          </div>
          {/* <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 *:w-full *:h-full">
            {generalIcons.arrowCard}
          </div> */}
        </div>
        <p className="text-gunMetal group-hover:text-white  text-sm md:text-base leading-5 md:leading-6 font-normal -tracking-[0.72px]">
          {content}
        </p>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="gradient-text bg-secondaryTextGrad inline-flex gap-2 items-center py-0 md:py-0 px-0 leading-none text-[16px] font-semibold font-serif *:hover:ml-1 *:duration-300 w-fit"
        >
          {urlName}
          <span className="size-6 *:size-full text-black group-hover:text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14.5143 6L20 12L14.5143 18M19.0857 12L4 12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="bevel"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
  );
}
